import sha256 from "crypto-js/sha256"
import Base64 from "crypto-js/enc-base64"
import {decodeToken} from "react-jwt"

export type OrganizationUserAccess = {
  organizationId: string
  userAccess: UserAccess[]
}
export type UserAccess = { groupId: string, groupName: string, roles: string[] }

export enum HashAlgorithm {
  SHA256 = "SHA256"
}

export const createHash = (algorithm: HashAlgorithm, data: string) =>
  Base64.stringify(sha256(data))

export const parseToken = (token: string): OrganizationUserAccess => {
  const {access: { userAccess, organizationId } } = decodeToken(token) as any
  return { userAccess, organizationId }
}